import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'
// import {Md5} from 'ts-md5';
import { RestServices } from '../../services/rest.services'

@Component({
    selector: 'app-plan', templateUrl: './plan.component.html', styleUrls: ['../promotion.component.css'],
})
export class PlanComponent implements OnInit {

    en = {}
    showEN = true
    ShopID = '9102390029812'
    OrderID
    DateTime
    ShopPassString
    Amount = 6000
    ClientField1
    ClientField2
    session = this.auth.getItem('user') ? true : false
    dataUser

    constructor(private auth: AuthService, private restService: RestServices) {
    }

    ngOnInit() {
        if (this.session) {
            this.dataUser = this.auth.getUser()
            this.ClientField1 = this.dataUser.registrationMail || ''
            this.ClientField2 = this.dataUser.name || ''
        }
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    onSubmit(form) {
        this.restService.http_post('getSize/payment', { amount: this.Amount }).subscribe(
            response => {
                this.OrderID = response['orderId']
                this.ShopPassString = response['passString']
                this.DateTime = response['dateTime']
                setTimeout(() => {
                    form.submit()
                }, 500)
            },
        )
    }

}



// WEBPACK FOOTER //
// ./src/app/promotion/plan/plan.component.ts